import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchItems } from '../../../../../hooks/useCrud';
import { usePagination } from '../../../../../hooks/usePagination';
import LoaderAndError from '../../../../../components/LoaderAndError';
import Pagination from '../../../../../components/Pagination';
import { fileUrl } from '../../../../../api/config';

interface UiTeam {
    id?: number;
    nom?: string;
    fonction?: string;
    email?: string;
    logo?: string;
    telephone?: string;
    facebook?: string;
    twitter?: string;
    linkedin?: string;
    logoFile?: File;

    createdAt?: string;
    updatedAt?: string;

}




export default function Team() {

    // declaration de variables
    const [listData, setDataList] = useState<UiTeam[]>([]);
    const [formData, setFormData] = useState<Partial<UiTeam>>({});
    const [isEditing, setIsEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(6);
    const [totalPages, setTotalPages] = useState(1);
    //fin declaration

    // declaration de la pagination
    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });

    // chargement de la table
    const loadlistData = async () => {
        setLoading(true);

        try {
            const res = await fetchItems<UiTeam>('/fetch_team_data', {
                q: search,
                page: currentPage,
                limit,
            });
            setDataList(res.data);
            setTotalPages(res.totalPages);


        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "Les talents derrière la révolution - Swiftride";
        loadlistData();

    }, [search, currentPage, limit]);
    return (
        <div className="container py-6">
            {/* Titre Section */}
            <div className="text-center mb-6">
                <h2 className="display-10 fw-bold text-primary">
                    <i className="fas fa-users me-3"></i>Rencontrez Notre Équipe
                </h2>
                <p className="lead text-muted">
                    Les talents derrière la révolution du basketball
                </p>
            </div>

            {/* Grille des Membres */}
            {/* Grille des Membres */}
            <div className="row g-4 justify-content-center">

                {listData.length === 0 ? (
                    <LoaderAndError
                        loading={loading}
                        error={error}
                        onClearError={() => setError(null)}
                    />
                ) : (
                    listData.map((item) => (
                        <div className="col-md-6 col-lg-4" key={item.id}>
                            <div
                                className="
                        team-card bg-white dark:bg-gray-900 shadow-sm border-0 rounded-4 
                        h-100 overflow-hidden position-relative 
                        transition-all duration-300 hover:shadow-lg hover:-translate-y-1
                    "
                            >
                                {/* Image */}
                                <div className="team-image-wrapper position-relative">
                                    <img
                                        src={fileUrl + '/images/' + item.logo!}
                                        alt={item.nom}
                                        className="
                                img-fluid w-100 h-100 object-cover 
                                team-image transition-transform duration-300
                            "
                                    />

                                    {/* Overlay Gradient */}
                                    <div
                                        className="
                                position-absolute bottom-0 start-0 end-0 p-3 
                                bg-gradient-to-t from-black/70 to-transparent 
                                text-white
                            "
                                    >
                                        <h4 className="fw-bold m-0 fs-4">{item.nom}</h4>
                                    </div>
                                </div>

                                {/* Body */}
                                <div className="card-body text-center py-4">
                                    <p className="text-muted mb-3 fs-6">
                                        {item.fonction}
                                    </p>

                                    {/* Icônes sociales */}
                                    <div className="d-flex justify-content-center gap-3">

                                        {item.telephone && item.telephone.trim() !== '' && (
                                            <a
                                                href={'tel:' + item.telephone}
                                                className="team-icon-link"
                                            >
                                                <i className="fas fa-phone"></i>
                                            </a>
                                        )}

                                        {item.email && item.email.trim() !== '' && (
                                            <a
                                                href={'mailto:' + item.email}
                                                className="team-icon-link"
                                            >
                                                <i className="fas fa-envelope"></i>
                                            </a>
                                        )}

                                        {item.facebook && item.facebook.trim() !== '' && (
                                            <a
                                                href={item.facebook}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="team-icon-link"
                                            >
                                                <i className="fab fa-facebook"></i>
                                            </a>
                                        )}

                                        {item.twitter && item.twitter.trim() !== '' && (
                                            <a
                                                href={item.twitter}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="team-icon-link"
                                            >
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                        )}

                                        {item.linkedin && item.linkedin.trim() !== '' && (
                                            <a
                                                href={item.linkedin}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="team-icon-link"
                                            >
                                                <i className="fab fa-linkedin"></i>
                                            </a>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}

            </div>


            <div className="row mb-1">
                <div className="text-center mt-5">
                    {/* pagination */}
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        paginationRange={paginationRange}
                        isCurrentPage={isCurrentPage}
                        isFirstPage={isFirstPage}
                        isLastPage={isLastPage}
                        onPageChange={setCurrentPage}
                        textCounter={true}
                    />
                    {/* fin pagination */}
                </div>
            </div>

           
        </div>
    )
}
